import { FC } from "react";
import { DRAFT_TEAM_STATUS, HIDDEN_TEAM_STATUS, REJECTED_TEAM_STATUS, UNDER_APPROVAL_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { DraftBadge, HiddenBadge, ModerationBadge, RejectedBadge } from "./styles";
import { useTranslation } from "react-i18next";

export const ExternalTeamBadge: FC<{ status?: number }> = ({ status }) => {
    const { t , i18n: { language }} = useTranslation();

    if (status === DRAFT_TEAM_STATUS) {
        return <DraftBadge>{t('panel.statuses.draft')}</DraftBadge>
    }

    if (status === UNDER_APPROVAL_TEAM_STATUS) {
        return <ModerationBadge>{t('panel.statuses.pending')}</ModerationBadge>
    }

    if (status === REJECTED_TEAM_STATUS) {
        return <RejectedBadge>{t('panel.statuses.rejected')}</RejectedBadge>
    }

    if (status === HIDDEN_TEAM_STATUS) {
        return <HiddenBadge>{t('panel.statuses.hidden')}</HiddenBadge>
    }

    return null
}import { FC } from "react";
import { DRAFT_TEAM_STATUS, HIDDEN_TEAM_STATUS, REJECTED_TEAM_STATUS, UNDER_APPROVAL_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { DraftBadge, HiddenBadge, ModerationBadge, RejectedBadge } from "./styles";
import { useTranslation } from "react-i18next";

export const ExternalTeamBadge: FC<{ status?: number }> = ({ status }) => {
    const { t , i18n: { language }} = useTranslation();

    if (status === DRAFT_TEAM_STATUS) {
        return <DraftBadge>{t('panel.statuses.draft')}</DraftBadge>
    }

    if (status === UNDER_APPROVAL_TEAM_STATUS) {
        return <ModerationBadge>{t('panel.statuses.pending')}</ModerationBadge>
    }

    if (status === REJECTED_TEAM_STATUS) {
        return <RejectedBadge>{t('panel.statuses.rejected')}</RejectedBadge>
    }

    if (status === HIDDEN_TEAM_STATUS) {
        return <HiddenBadge>{t('panel.statuses.hidden')}</HiddenBadge>
    }

    return null
}